import { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { todayYMD } from '../utils/dates';

const MiniCalendar = ({ selectedDates, onToggleDate, activityDates }) => {
  const todayStr = todayYMD();
  const [viewYM, setViewYM] = useState(() => {
    const d = new Date();
    return { year: d.getFullYear(), month: d.getMonth() };
  });

  const prevMonth = () => setViewYM(({ year, month }) => {
    const d = new Date(year, month - 1, 1);
    return { year: d.getFullYear(), month: d.getMonth() };
  });
  const nextMonth = () => setViewYM(({ year, month }) => {
    const d = new Date(year, month + 1, 1);
    return { year: d.getFullYear(), month: d.getMonth() };
  });

  const firstOfMonth = new Date(viewYM.year, viewYM.month, 1);
  const daysInMonth = new Date(viewYM.year, viewYM.month + 1, 0).getDate();
  let startOffset = firstOfMonth.getDay() - 1;
  if (startOffset < 0) startOffset = 6;

  const actSet = new Set(activityDates);
  const selSet = new Set(selectedDates);

  const cells = [];
  for (let i = 0; i < startOffset; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) {
    const mm = String(viewYM.month + 1).padStart(2, '0');
    const dd = String(d).padStart(2, '0');
    cells.push(`${viewYM.year}-${mm}-${dd}`);
  }

  const monthLabel = firstOfMonth.toLocaleString('default', { month: 'long', year: 'numeric' });

  return (
    <div className="mt-3 select-none">
      <div className="flex items-center justify-between mb-2">
        <button onClick={prevMonth} className="p-1 rounded hover:bg-gray-100 text-gray-500 transition-colors" data-testid="cal-prev">
          <ChevronLeft size={13} />
        </button>
        <span className="text-[11px] font-semibold text-gray-600">{monthLabel}</span>
        <button onClick={nextMonth} className="p-1 rounded hover:bg-gray-100 text-gray-500 transition-colors" data-testid="cal-next">
          <ChevronRight size={13} />
        </button>
      </div>
      <div className="grid grid-cols-7 mb-0.5">
        {['M', 'T', 'W', 'T', 'F', 'S', 'S'].map((d, i) => (
          <div key={i} className="text-center text-[9px] text-gray-400 font-semibold py-0.5">{d}</div>
        ))}
      </div>
      <div className="grid grid-cols-7 gap-y-0.5">
        {cells.map((dateStr, i) => {
          if (!dateStr) return <div key={i} />;
          const isToday = dateStr === todayStr;
          const isSelected = selSet.has(dateStr);
          const hasActivity = actSet.has(dateStr);
          return (
            <button
              key={dateStr}
              onClick={() => onToggleDate(dateStr)}
              className={`relative flex flex-col items-center justify-center rounded py-0.5 text-[11px] font-medium transition-colors leading-none
                ${isSelected ? 'bg-green-600 text-white' : isToday ? 'ring-1 ring-green-500 text-green-700 bg-green-50' : 'hover:bg-gray-100 text-gray-700'}`}
              data-testid={`cal-day-${dateStr}`}
            >
              {new Date(dateStr + 'T00:00:00').getDate()}
              {hasActivity && (
                <span className={`w-1 h-1 rounded-full mt-0.5 ${isSelected ? 'bg-white/70' : 'bg-green-500'}`} />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default MiniCalendar;
